<div class="d-flex align-items-center mb-3">
  <div class="h3">{{ 'affiliate_partnership_headline' | i18next }}</div>
</div>

<div class="row align-items-stretch mb-3">
  <div class="col-xs-12 col-md-12 col-lg-12 mb-sm-3 mb-md-0">
    <div class="card h-100 card-nb card-nm">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12 highlighted">
            <h4>{{ 'affiliate_become_partner_headline' | i18next }}</h4>
          </div>
        </div>
        <div class="row subinformations">
          <div class="col-12">
            {{ 'affiliate_become_partner_content_text' | i18next }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row align-items-stretch mb-3">
  <div class="col-xs-12 col-md-12 col-lg-12">
    <div class="card h-100 card-nb card-nm">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12 highlighted">
            <h4>{{ 'affiliate_company_description_headline' | i18next }}</h4>
          </div>
        </div>
        <div class="row subinformations">
          <div class="col-12">
            {{ 'affiliate_company_description_content_text' | i18next }}
          </div>
        </div>
        <div class="row subinformations">
          <div class="col-12">
            <app-input-textarea [autoFocus]="true" [control]="form.get('company_description')" name="partner_description" label="" [options]="{ cols: '30', rows: '10', minlength: '50', maxlength: '3000' }"></app-input-textarea>
            @if (partnerDescription.length < 50) {
              <p class="red">{{ 'affiliate_still_chars' | i18next: {number: (50 - partnerDescription.length)} }}</p>
            }
            @if (partnerDescription.length >= 50) {
              <p>{{partnerDescription.length}}/3000</p>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row align-items-stretch mb-3">
  <div class="col-xs-12 col-md-12 col-lg-12">
    <div class="card h-100 card-nb card-nm">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12 highlighted">
            <h4>{{ getTradingLicenseByType('headline') | i18next }}</h4>
          </div>
        </div>
        <div class="row subinformations">
          <div class="col-12">
            {{ getTradingLicenseByType('text') | i18next }}
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <input class="w-75" type="file" name="file" accept="application/pdf" (change)="getFile($event)">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (initialized) {
  <div>
    @if (!hasBankAccount) {
      <div class="row align-items-stretch mb-3" >
        <div class="col-xs-12 col-md-12 col-lg-12">
          <div class="card h-100 card-nb card-nm">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h4>{{ 'payment_details_form_header' | i18next }}</h4>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-sepa-form [autoFocus]="false" [bankAccount]="bankAccount" [submitForm]="false" (formChange)="onSepaChanged($event)"></app-sepa-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (showVAT) {
      <div class="row align-items-stretch mb-3" >
        <div class="col-xs-12 col-md-12 col-lg-12">
          <div class="card h-100 card-nb card-nm">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h4>{{ 'company_details_form_header' | i18next }}</h4>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-input-text [control]="form.get('vat')" name="company_vat"></app-input-text>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}

<div class="d-flex justify-content-end mt-2 mb-3">
  <button (click)="send()" [disabled]="isDisabled" class="btn btn-outline-primary">{{'affiliate_apply_partnership_text' | i18next }}</button>
</div>
